<div class="multiple-auth-list">
  <bzg-button-primary *ngIf="!selectedMultipleAuthenticator" class="multiple-auth-list__add-btn" icon="icon-plus" [disabled]="isDisabled" (click)="addAuthenticator()">
    {{ 'AUTHENTICATION.ADD_AUTHENTICATOR' | translate }}
  </bzg-button-primary>

  <div *ngIf="selectedMultipleAuthenticator">
    <div class="multiple-auth-list__authenticators multiple-auth-list__authenticators-selected">
      <bzg-icon class="multiple-auth-list__authenticators-item-back" nameIcon="icon-arrow-left-bold" (click)="onBackToList()"></bzg-icon>
      <div class="multiple-auth-list__authenticators-item" (click)="onShowInfoAuthenticator()">
        <div class="multiple-auth-list__authenticators-item-name">{{selectedMultipleAuthenticator.displayName}}</div>
        <div class="multiple-auth-list__authenticators-item-type">{{selectedMultipleAuthenticator.type}}</div>
      </div>
    </div>
  </div>

  <div class="multiple-auth-list__header" *ngIf="!selectedMultipleAuthenticator">
    <span class="multiple-auth-list__header-title">{{ 'AUTHENTICATION.AUTHENTICATOR_LIST' | translate }}</span>
    <bzg-icon *ngIf="!isDisabled && !deleteActivated" class="multiple-auth-list__header-icon" [nameIcon]="'icon-delete'"
      [size]="16" (click)="onDeleteOption()">
    </bzg-icon>
    <div *ngIf="deleteActivated" class="multiple-auth-list__header-delete-buttons">
      <bzg-button-secondary [disabled]="isDisabled" [size]="'s'" (click)="onCancelDelete()">
        {{'GLOBAL.CANCEL' | translate}}</bzg-button-secondary>
      <bzg-button-secondary [size]="'s'" [disabled]="selectedItemsForDeletion.length === 0 || isDisabled" (click)="onShowConfirmation()">
        {{'GLOBAL.DELETE' | translate}}
      </bzg-button-secondary>
    </div>
  </div>

  <div class="multiple-auth-list__search" *ngIf="!selectedMultipleAuthenticator">
    <bzg-input [placeholder]="('AUTHENTICATION.SEARCH_BY' | translate) + '...'"
      class="multiple-auth-list__search-box__text" name="search-box" [(ngModel)]="searchValue"
      (ngModelChange)="onSearchChange()"
      actionIcnPosition="right">
      <bzg-icon nameIcon="icon-search"></bzg-icon>
    </bzg-input>
  </div>

  <div *ngIf="!selectedMultipleAuthenticator">
    <div class="multiple-auth-list__authenticators" *ngFor="let auth of filteredAuthenticatorList" (click)="onSelectAuthenticator(auth)">
      <bzg-checkbox class="multiple-auth-list__authenticators-item-checkbox" *ngIf="deleteActivated" [(ngModel)]="auth.selected" 
        (ngModelChange)="onCheckboxChange(auth)" (click)="$event.stopPropagation()" [disabled]="isDisabled"></bzg-checkbox>
      <div class="multiple-auth-list__authenticators-item">
        <div class="multiple-auth-list__authenticators-item-name">{{auth.displayName}}</div>
        <div class="multiple-auth-list__authenticators-item-type">{{auth.type}}</div>
      </div>
      <bzg-icon nameIcon="icon-arrow-right-bold"></bzg-icon>
    </div>
  </div>
  <div *ngIf="selectedMultipleAuthenticator" class="multiple-auth-list__options">
    <div class="multiple-auth-list__options-item" *ngFor="let item of items" title="{{item.translation}}"
      [ngClass]="{'multiple-auth-list__item--selected': selectItemInput && ((selectItemInput.key && selectItemInput.key === item.key) || (selectItemInput.name && selectItemInput.name === item.name))}"
      (click)="onSelectItem(item)">
      <bzg-icon class="bz-space--inline-m" [nameIcon]="'icon-user-authentication'" [size]="16"></bzg-icon>
      <span>{{item.translation}}</span>
    </div>
  </div>
</div>

